export const AppPermissions = {
    // Main permissions
    PortalAccess: ["SBTAD.PortalAccess@SBTAD"],
}